import { UserRound } from "lucide-react";
import { staffInitials } from "./staff-step9";
export default function StaffAvatar({name,size="sm"}:{name:string;size?:string}) {
  const initials=staffInitials(name);
  return <span className={`av ${size}`} aria-hidden="true">{initials||<UserRound size={size==="big"?24:16}/>}</span>;
}
